import {
    STUDY_LEVEL_LIST_REQUEST,
    STUDY_LEVEL_LIST_SUCCESS,
    STUDY_LEVEL_LIST_FAIL,
    STUDY_LEVEL_CREATE_REQUEST,
    STUDY_LEVEL_CREATE_SUCCESS,
    STUDY_LEVEL_CREATE_FAIL
} from '../constants/studyLevelConstants'

export const studylevelListReducer = (state = {}, action) => {
    switch (action.type) {
        case STUDY_LEVEL_LIST_REQUEST:
            return { loading: true }
        case STUDY_LEVEL_LIST_SUCCESS:
            return { loading: false, studyLevels: action.payload }
        case STUDY_LEVEL_LIST_FAIL:
            return { loading: false, error: action.payload }
        default:
            return state
    }
}

export const studyLevelsetReducer = (state = {}, action) => {
    switch (action.type) {
        case STUDY_LEVEL_CREATE_REQUEST:
            return { loading: true }
        case STUDY_LEVEL_CREATE_SUCCESS:
            return { loading: false, levls: action.payload }
        case STUDY_LEVEL_CREATE_FAIL:
            return { loading: false, error: action.payload }
        default:
            return state
    }
}

